// Linkovi ka prodavnicama aplikacija. Kad neka verzija još nije odobrena,
// vrednost ostaje null — bedž se tada prikazuje kao najava („Uskoro"), a ne
// kao mrtav link.
export const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=rs.busgo.travel";
export const IOS_APP_URL = "https://apps.apple.com/rs/app/busgo/id6793416961";
